import yup, { ERROR_MESSAGES } from 'utils/yup';

export const getMergeItineraryValidationSchema = ({
  isShowDatePicker,
  isShowDayPicker,
}: {
  isShowDatePicker: boolean;
  isShowDayPicker: boolean;
}) => {
  const shape = {
    sampleId: yup.string().nullable().required(ERROR_MESSAGES.required),
    date: null,
    day: null,
  };

  if (isShowDatePicker) {
    shape.date = yup.object().shape({
      start: yup.string().nullable().required(ERROR_MESSAGES.required),
    });
  }

  if (isShowDayPicker) {
    shape.day = yup.object().shape({
      start: yup.number().nullable().required(ERROR_MESSAGES.required),
    });
  }

  return yup.object().shape(shape);
};
